/** אזורי התנדבות מועדפים לקבוצה. */
export const GROUP_VOLUNTEER_REGIONS = ["NORTH", "CENTER", "SOUTH"] as const;

export type GroupVolunteerRegion = (typeof GROUP_VOLUNTEER_REGIONS)[number];

export const GROUP_VOLUNTEER_REGION_LABELS: Record<
  GroupVolunteerRegion,
  string
> = {
  NORTH: "צפון",
  CENTER: "מרכז",
  SOUTH: "דרום",
};

export function isGroupVolunteerRegion(
  value: unknown,
): value is GroupVolunteerRegion {
  return (
    typeof value === "string" &&
    (GROUP_VOLUNTEER_REGIONS as readonly string[]).includes(value)
  );
}

export function parseGroupVolunteerRegions(
  value: unknown,
): GroupVolunteerRegion[] {
  if (!Array.isArray(value)) return [];
  return value.filter(isGroupVolunteerRegion);
}

export function normalizeGroupVolunteerRegions(
  regions: GroupVolunteerRegion[],
): GroupVolunteerRegion[] {
  const seen = new Set<GroupVolunteerRegion>();
  const out: GroupVolunteerRegion[] = [];
  for (const r of regions) {
    if (!seen.has(r)) {
      seen.add(r);
      out.push(r);
    }
  }
  return out;
}

export const GROUP_VOLUNTEER_REGIONS_REQUIRED_MESSAGE =
  "יש לבחור לפחות אזור התנדבות אחד";

export function toggleGroupVolunteerRegion(
  current: GroupVolunteerRegion[],
  region: GroupVolunteerRegion,
): GroupVolunteerRegion[] {
  const set = new Set(current);
  if (set.has(region)) {
    set.delete(region);
  } else {
    set.add(region);
  }
  return GROUP_VOLUNTEER_REGIONS.filter((r) => set.has(r));
}
